/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Flex,
  message,
  Badge,
  Card,
  Select,
  Typography,
  Divider,
  InputNumber,
  Upload,
  Modal,
} from "antd";
import { Row, Col, Space } from "antd";
// import { Upload,Modal } from "antd";
import { SaveFilled, SearchOutlined } from "@ant-design/icons";
import { ButtonBack, uploadButton } from "../../../components/button/index.js";
// import { uploadButton } from "../../../components/button/index.js";
import { useLocation, useNavigate } from "react-router";
import { delay, BACKEND_URL_MAIN } from "../../../utils/util.js";
import Swal from "sweetalert2";
// import { BACKEND_URL_MAIN } from "../../../utils/util.js";
// import Swal from "sweetalert2";
import FGservice from "../../../service/ERP/FG.service.js";
import OptionService from "../../../service/ERP/Options.service.js";
import { Authenticate } from "../../../service/Authenticate.service.js";

import ModalPK from "../../../components/modal/ERP/pk/ModalPK";
import ModalProductionSystem from "../../../components/modal/ERP/production-system/ModalProductionSystem";
import ProductionSystemService from "../../../service/ERP/ProductionSystem.service.js";
import ModalLid from "../../../components/modal/ERP/pk/ModalPK";
import ModalEtc from "../../../components/modal/ERP/pk/ModalPK";
import ModalUnit from "../../../components/modal/ERP/unit/ModalUnit.jsx";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const fgservice = FGservice();
const psService = ProductionSystemService();
const opService = OptionService();
const authService = Authenticate();
const { Text } = Typography;

const from = "/ERP/finished-goods";

const ItemManage = () => {
  const { TextArea } = Input;
  const navigate = useNavigate();
  const location = useLocation();

  const { config } = location.state || { config: null };
  /* โหมดดูอย่างเดียว — ปิดการแก้ไขทั้งฟอร์ม ซ่อนปุ่มบันทึก */
  const isView = config?.action === "view";
  const [form] = Form.useForm();
  // const [formImage] = Form.useForm();
  const [formDetail, setFormDetail] = useState([]);
  const [optionPrefix, setOptionPrefix] = useState([]);
  const [openModalPK, setOpenModalPK] = useState(false);
  const [openModalLid, setOpenModalLid] = useState(false);
  const [openModalEtc, setOpenModalEtc] = useState(false);
  const [openModalUnit, setOpenModalUnit] = useState(false);
  /* ระบบการผลิต — dropdown + จัดการรายการได้ในตัว */
  const [openModalPdSystem, setOpenModalPdSystem] = useState(false);
  const [pdSystemOption, setPdSystemOption] = useState([]);

  const loadPdSystem = () => {
    psService
      .list()
      .then((res) =>
        setPdSystemOption(
          (res.data?.data || []).map((o) => ({ value: o.name, label: o.name }))
        )
      )
      .catch(() => {});
  };

  useEffect(() => {
    loadPdSystem();
  }, []);
  const [prefixCode, setPrefixCode] = useState(null);
  const [fgCode, setFgCode] = useState("");

  /// upload image
  const [fileList, setFileList] = useState([]);
  const [previewImage, setPreviewImage] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewTitle, setPreviewTitle] = useState("Preview");

  useEffect(() => {
    // setLoading(true);
    GetPrefix();
    if (config?.action !== "create") {
      getsupData(config.code);
    } else {
      form.setFieldValue("net_weight", 1);
    }
    // console.log(config);

    return () => {
      form.resetFields();
    };
  }, []);

  useEffect(() => {
    fnsetFGcode(); // อัปเดตค่า fgCode เมื่อฟอร์มเปลี่ยนแปลง
    // alert(fgCode);
  }, [form.getFieldValue("fg_code")]);

  const handlePreview = async (file) => {
    // console.log(file)
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    // setPreviewTitle(
    //   // file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    // );
  };

  const handleRemove = (file) => {
    const newFileList = fileList.filter((f) => f.uid !== file.uid);
    setFileList(newFileList);
    //message.success(`File deleted successfully`);
  };

  const onRemove = (file) => {
    // console.log(file);
    //debugger
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          const formData_Del = new FormData();
          formData_Del.append("img_id", file.img_id);
          formData_Del.append("file", file);
          formData_Del.append("uid", file.uid);
          formData_Del.append("stcode", form.getFieldValue("fg_code"));
          formData_Del.append("filename", file.name);

          const actions =
            config?.action !== "create"
              ? fgservice.deletePicUpdate(formData_Del)
              : fgservice.deletePic(formData_Del);

          actions.then(async (res) => {
            //debugger
            let { status, data } = res;
            if (status === 200 && data.status === "1") {
              handleRemove(file);
            } else {
              // alert(data.message)
            }
          });
        } catch (error) {
          message.error("Failed to delete file");
        }
      }
    });

    // console.log(fileList);
  };

  const onUploadSuccess = (file) => {
    //debugger
    // alert(`${BACKEND_URL_MAIN}/uploads/` + file.uid + "_" + file.name);
    const newFile = {
      uid: file.uid,
      name: file.name,
      status: "done",
      url:
        `${BACKEND_URL_MAIN}/uploads/ERP/Items/` +
        form.getFieldValue("fg_code") +
        "/" +
        "Item_Pic" +
        "_" +
        file.name,
      // url: `${BACKEND_URL_MAIN}/uploads/ERP/Items/`+ form.getFieldValue("fg_code") + '/' + file.uid + "_" + file.name,
    };
    setFileList((prevFileList) => [...prevFileList, newFile]);
    // console.log(file);
    // console.log('-----');
    // console.log(fileList);
  };

  const fnsetFGcode = () => {
    setFgCode(
      (form.getFieldValue("prefixLabel") !== undefined
        ? form.getFieldValue("prefixLabel")
        : "") +
        (form.getFieldValue("prefixLabel") !== undefined &&
        form.getFieldValue("fg_code") !== undefined
          ? "-"
          : "") +
        (form.getFieldValue("fg_code") !== undefined
          ? form.getFieldValue("fg_code")
          : ""),
    ); // อัปเดตค่า fgCode เมื่อฟอร์มเปลี่ยนแปลง
  };

  const GetPrefix = () => {
    opService.optionsRuncode({ p: "fg" }).then((res) => {
      let { data } = res.data;
      // let code = data.run_number
      setOptionPrefix(data);
    });
  };

  const handleChoosedPK = (value) => {
    // console.log(value);
    const f = form.getFieldValue();
    const initialValues = {
      ...formDetail,
      ...f,
      pk_code: value.pk_code,
      pk_name: value.pk_name,
    };
    form.setFieldsValue(initialValues);
    setFormDetail(initialValues);
  };

  const handleChoosedLid = (value) => {
    // console.log(value);
    const f = form.getFieldValue();
    const initialValues = {
      ...formDetail,
      ...f,
      lid_code: value.pk_code,
      lid_name: value.pk_name,
    };
    form.setFieldsValue(initialValues);
    setFormDetail(initialValues);
  };

  const handleChoosedEtc = (value) => {
    // console.log(value);
    const f = form.getFieldValue();
    const initialValues = {
      ...formDetail,
      ...f,
      etc_code: value.pk_code,
      etc_name: value.pk_name,
    };
    form.setFieldsValue(initialValues);
    setFormDetail(initialValues);
  };

  const handleChoosedUnit = (value) => {
    // console.log(value);
    const f = form.getFieldValue();
    const initialValues = {
      ...formDetail,
      ...f,
      unit: value.unitname,
    };
    form.setFieldsValue(initialValues);
    setFormDetail(initialValues);
  };

  const getsupData = (v) => {
    fgservice
      .get(v)
      .then(async (res) => {
        const { data, file } = res.data;

        const init = {
          ...data,
        };

        setFormDetail(init);
        form.setFieldsValue({ ...init });
        form.setFieldValue("fg_code1", data.fg_code);

        let fileurl = file.map((data) => ({
          ...data,
          file_name:
            `${BACKEND_URL_MAIN}/uploads/ERP/Items/` +
            form.getFieldValue("fg_code") +
            "/" +
            data.file_name,
        }));
        // console.log(fileurl) ;
        const formattedFileList = fileurl.map((data) => ({
          img_id: data.img_id,
          uid: data.uid,
          name: data.name,
          status: "done",
          url: data.file_name,
        }));
        setFileList(formattedFileList);
        form.setFieldsValue({ prod_img: formattedFileList });
      })
      .catch((err) => {
        console.log(err);
        message.error("Error getting infomation FG.");
      });
  };

  const handleConfirm = () => {
    form.validateFields().then(() => {
      const source = {
        ...formDetail,
        ...form.getFieldsValue(),
        prefixLabel: form.getFieldValue("prefixLabel"),
      };

      const actions =
        config?.action !== "create"
          ? fgservice.update(source)
          : fgservice.create(source);

      actions
        .then(async (r) => {
          message.success("Request success.");
          navigate(from, { replace: true });
          await delay(300);
        })
        .catch((err) => {
          console.warn(err);
          const data = err?.response?.data;
          message.error(data?.message || "บันทึกไม่สำเร็จ");
        });
    });
  };

  const handleCancel = () => setPreviewOpen(false);

  const dividerProp = {
    orientation: "left",
    style: { marginBlock: 10 },
    className: "!border-black",
  };

  const prefixSelector = (
    <Form.Item name="prefixid" noStyle>
      <Select
        style={{
          width: 350,
          textAlign: "left",
          paddingLeft: "10px",
        }}
        onChange={(v, l) => {
          form.setFieldValue("prefixLabel", l.text);
          // หรือเก็บใน state
          setPrefixCode(l.id);
          opService
            .optionsGetLastcode({ p: "packaging", id: v })
            .then((res) => {
              let { data } = res;
              setPrefixCode(data.data);
              const val = {
                ...formDetail,
                prefix: l.label,
              };
              setFormDetail(val);
            });
          fnsetFGcode();
        }}
        options={optionPrefix.map((item) => ({
          value: item.id,
          label: item.value + " - " + item.definition,
          text: item.value,
        }))}
      ></Select>
    </Form.Item>
  );

  let redcode = (
    <>
      {fgCode && fgCode !== "NaN" && (
        <span style={{ paddingLeft: "20px" }}>
          {"ตัวอย่างรหัสใหม่ " + fgCode}
        </span>
      )}
      <span style={{ color: "red", paddingLeft: "10px" }}>
        {prefixCode !== null ? " รหัสล่าสุด " + prefixCode : ""}
      </span>
    </>
  );

  const propsAdd = {
    customRequest: async ({ file, onSuccess, onError }) => {
      if (
        form.getFieldValue("fg_code") !== "" &&
        form.getFieldValue("fg_code") !== undefined
      ) {
        // console.log(fileList);
        const allowedExtensions = [".jpg", ".jpeg", ".png", ".gif"]; // รายการสกุลไฟล์ที่อนุญาต
        const fileExtension = file.name.slice(
          ((file.name.lastIndexOf(".") - 1) >>> 0) + 2,
        ); // สกุลไฟล์ของไฟล์ที่อัพโหลด
        if (!allowedExtensions.includes(`.${fileExtension.toLowerCase()}`)) {
          message.error("สกุลไฟล์ไม่ถูกต้อง");
          onError();
          return false;
        } else {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("uid", file.uid);
          formData.append("stcode", form.getFieldValue("fg_code"));
          formData.append("stcode_type", "FG");
          // console.log(file)
          try {
            fgservice.uploadPic(formData).then(async (res) => {
              //debugger
              let { status, data } = res;
              if (status === 200 && data.status === "1") {
                onUploadSuccess(file);
                onSuccess();
                message.success(`${file.name} file uploaded successfully`);
              } else {
                // alert(data.message)
              }
            });
          } catch (error) {
            onError(error);
            message.error(`${file.name} file upload failed.`);
          }
        }
        // console.log(fileList);
      } else message.error(`กรุณากรอกรหัสสินค้าก่อน.`);
    },
  };

  const Detail = (
    <>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Divider {...dividerProp}>Basic Data</Divider>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          style={
            config.action !== "edit"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item
            label={
              <span>
                <span>FG Code</span>
                {redcode}
              </span>
            }
            name="fg_code"
            rules={[{ required: true, message: "Please enter data!" }]}
          >
            <Input
              addonBefore={
                <Text
                  style={{
                    width: 150,
                  }}
                >
                  {prefixSelector}
                </Text>
              }
              onChange={() => fnsetFGcode()}
              placeholder="Enter FG Code."
            />
          </Form.Item>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          style={
            config.action === "edit" || config.action === "view"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item label="FG Code" name="fg_code1">
            <Input readOnly />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
          <Form.Item
            label="FG Thai Name"
            name="fg_name"
            rules={[{ required: true, message: "โปรดกรอกข้อมูล" }]}
          >
            <Input placeholder="Enter FG Thai Name" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
          <Form.Item label="FG English Name" name="fg_nameEN">
            <Input placeholder="Enter FG English Name" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={6} lg={6} xl={6} xxl={6}>
          <Form.Item name="code" label="Code">
            <Input placeholder="Enter Code" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={6}>
          <Form.Item label="หน่วยสินค้า :" name="unit">
            <Space.Compact style={{ width: "100%" }}>
              <Input
                readOnly
                placeholder="Select Unit"
                value={!!formDetail.unit ? `${formDetail.unit} ` : ""}
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => setOpenModalUnit(true)}
                style={{ minWidth: 40 }}
              ></Button>
            </Space.Compact>
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <Form.Item label="บรรจุภัณฑ์ :" name="pk_code">
            <Space.Compact style={{ width: "100%" }}>
              <Input
                readOnly
                placeholder="เลือก บรรจุภัณฑ์"
                value={
                  !!formDetail.pk_name
                    ? `${formDetail.pk_code} / ${formDetail.pk_name} `
                    : ""
                }
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => setOpenModalPK(true)}
                style={{ minWidth: 40 }}
              ></Button>
            </Space.Compact>
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <Form.Item label="ฝาปิด :" name="lid_code">
            <Space.Compact style={{ width: "100%" }}>
              <Input
                readOnly
                placeholder="เลือก ฝาปิด"
                value={
                  !!formDetail.lid_name
                    ? `${formDetail.lid_code} / ${formDetail.lid_name} `
                    : ""
                }
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => setOpenModalLid(true)}
                style={{ minWidth: 40 }}
              ></Button>
            </Space.Compact>
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <Form.Item label="อื่นๆ :" name="etc_code">
            <Space.Compact style={{ width: "100%" }}>
              <Input
                readOnly
                placeholder="เลือก อื่นๆ"
                value={
                  !!formDetail.etc_name
                    ? `${formDetail.etc_code} / ${formDetail.etc_name} `
                    : ""
                }
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => setOpenModalEtc(true)}
                style={{ minWidth: 40 }}
              ></Button>
            </Space.Compact>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <Form.Item name="allergen" label="สารก่อภูมิแพ้ :">
            <TextArea rows={2} placeholder="กรอกข้อมูลสารก่อภูมิแพ้" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          {/* ระบบการผลิต — เลือกจากทะเบียน เพิ่ม/แก้ไขได้จากปุ่มค้นหา */}
          <Form.Item name="production_system" label="ระบบการผลิต :">
            <Select
              allowClear
              showSearch
              optionFilterProp="label"
              size="large"
              placeholder="เลือกระบบการผลิต"
              options={pdSystemOption}
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <div style={{ padding: "6px 8px", borderTop: "1px solid #f0f0f0" }}>
                    <Button
                      type="link"
                      size="small"
                      onClick={() => setOpenModalPdSystem(true)}
                    >
                      + จัดการระบบการผลิต
                    </Button>
                  </div>
                </>
              )}
            />
          </Form.Item>
        </Col>
      </Row>
      <Divider {...dividerProp}>ข้อมูลใช้คำนวน</Divider>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <Form.Item name="net_weight" label="Net Weight">
            <InputNumber
              style={{ width: "100%" }}
              size="large"
              min="0"
              step="0.01"
              placeholder="Enter Net Weight "
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <Form.Item name="shelf_life" label="Shelf life">
            <InputNumber
              style={{ width: "100%" }}
              addonAfter="วัน"
              size="large"
              min="0"
              step="0.01"
              placeholder="ใส่วัน Shelf life"
            />
          </Form.Item>
        </Col>
      </Row>
      <Divider {...dividerProp}>Other Data</Divider>
      <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={8}
          style={
            config.action === "edit" || config.action === "view"
              ? { display: "inline" }
              : { display: "none" }
          }
        >
          <Form.Item label="สถานะการใช้งาน" name="active_status">
            <Select
              size="large"
              options={[
                {
                  value: "เปิดการใช้งาน",
                  label: <Badge status="success" text="เปิดการใช้งาน" />,
                },
                {
                  value: "ปิดการใช้งาน",
                  label: <Badge status="error" text="ปิดการใช้งาน" />,
                },
              ]}
            />
          </Form.Item>
        </Col>
        {/* <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <Form.Item name="feature" label="Feature">
            <TextArea rows={4} placeholder="Enter Feature" />
          </Form.Item>
        </Col> */}
        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <Form.Item name="remarks" label="Remark">
            <TextArea rows={4} placeholder="Enter Remark " />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
          รูปสินค้า
          <Form.Item
            name="prod_img"
            getValueFromEvent={(event) => {
              return event?.fileList;
            }}
            // rules={[
            //   {
            //     required: true,
            //     message: "กรุณาอัพโหลดรูปสินค้า!",
            //   },
            // ]}
          >
            <Upload
              {...propsAdd}
              fileList={fileList}
              listType="picture-card"
              onPreview={handlePreview}
              onRemove={onRemove}
            >
              {fileList.length >= 1 ? null : uploadButton}
            </Upload>
          </Form.Item>
        </Col>
      </Row>
    </>
  );

  const SectionBottom = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          <ButtonBack target={from} />
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          {!isView && (
            <Button
              icon={<SaveFilled style={{ fontSize: "1rem" }} />}
              type="primary"
              style={{ width: "9.5rem" }}
              onClick={() => {
                handleConfirm();
              }}
            >
              บันทึก
            </Button>
          )}
        </Flex>
      </Col>
    </Row>
  );
  return (
    <div className="fg-manage xs:px-0 sm:px-0 md:px-8 lg:px-8">
      {/* <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewImage}
        />
      </Modal> */}
      <Space direction="vertical" className="flex gap-2">
        <Form
          form={form}
          name="form_in_modal_add"
          layout="vertical"
          autoComplete="off"
          disabled={isView}
          initialValues={{
            modifier: "public",
          }}
        >
          <Card title={config?.title}>{Detail}</Card>
        </Form>
        {SectionBottom}
      </Space>

      {openModalPdSystem && (
        <ModalProductionSystem
          show={openModalPdSystem}
          close={() => setOpenModalPdSystem(false)}
          onChanged={loadPdSystem}
        />
      )}

      {openModalPK && (
        <ModalPK
          show={openModalPK}
          close={() => {
            setOpenModalPK(false);
          }}
          values={(v) => {
            handleChoosedPK(v);
          }}
        ></ModalPK>
      )}

      {openModalLid && (
        <ModalLid
          show={openModalLid}
          close={() => {
            setOpenModalLid(false);
          }}
          values={(v) => {
            handleChoosedLid(v);
          }}
        ></ModalLid>
      )}

      {openModalEtc && (
        <ModalEtc
          show={openModalEtc}
          close={() => {
            setOpenModalEtc(false);
          }}
          values={(v) => {
            handleChoosedEtc(v);
          }}
        ></ModalEtc>
      )}

      {openModalUnit && (
        <ModalUnit
          show={openModalUnit}
          close={() => {
            setOpenModalUnit(false);
          }}
          values={(v) => {
            handleChoosedUnit(v);
          }}
        ></ModalUnit>
      )}

      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
        width={1200}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewImage}
        />
      </Modal>
    </div>
  );
};

export default ItemManage;
